const Title = ({ titleRow1, titleRow2 }) => {
  const base =
    'w-full max-w-[290px] md:max-w-[640px] flex flex-col text-displayMobile md:text-displayDesktop text-olive wrap-anywhere font-ttDrugsTrial'
  return (
    <div className={base}>
      <span>{titleRow1}</span>
      <span>{titleRow2}</span>
    </div>
  )
}

export default Title
